import React, { Component } from 'react';
import { connect } from "react-redux";
import SubscriptionDetailDrawer from './subscriptionDetailDrawer';

import Grid from '@material-ui/core/Grid';

import { withStyles } from '@material-ui/core/styles';
import '../core/dashboard.css';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from '@material-ui/core/IconButton';
import { red, orange, grey, green } from '@material-ui/core/colors';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import {setStep, reloadData, setCloneState} from '../redux/actions';
import 'react-dates/initialize';
import WarningIcon from '@material-ui/icons/Warning';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CoreDialog  from '../core/dialog'
import Alert from '@material-ui/lab/Alert';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import SubscriptionAddPlan from './subscriptionAddPlan';
import CodeIcon from '@material-ui/icons/Code';
import CodeDialog  from '../core/code-dialog';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import SubscriptionEditDialog from './SubscriptionEditDialog';


import 'react-dates/lib/css/_datepicker.css';
import './subscriptions.css';


const styles = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        flexGrow: 1,       
    },          
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    title: {
        flexGrow: 1,
        color: '#fff',
        fontSize: '1.3rem'
    },
    appBar:{
        backgroundColor: '#3c8dbc'
    },
    nameCell:{
        width: '25%',
    },
    fabEdit:{
        backgroundColor: '#3c8dbc',
        color: '#fff',
        '&:hover':{
            backgroundColor: '#346785',
        }
    },
    fabWarning:{
        backgroundColor: grey[500],
        color: '#fff',
        '&:hover':{
            backgroundColor: grey[600],
        }
    }, 
    fabInactive:{
        backgroundColor: grey[300],
        color: '#fff',
        '&:hover':{
            backgroundColor: grey[300],
        }
    },    
    fabGo:{
        backgroundColor: green[500],
        color: '#fff',
        '&:hover':{
            backgroundColor: green[600],
        }
    },      
    fabDelete:{
        backgroundColor: red[500],
        color: '#fff',
        '&:hover':{
            backgroundColor: red[600],
        }
    },
    fabClone:{
        backgroundColor: '#FFA500',
        color: '#fff',
        '&:hover':{
            backgroundColor: '#ea9700',
        }
    },
    fabCode:{
        backgroundColor: orange[500],
        color: '#fff',
        '&:hover':{
            backgroundColor: orange[600],
        }
    },                 
    fabIcon:{
        '& .MuiSvgIcon-root':{
            fill: '#fff',
            color: '#fff',
            '&:hover':{
                color: '#ffe',
            }
        }
    }, 
    fabAction:{
        backgroundColor: '#FFA500',
        color: '#fff',
        '&:hover':{
            backgroundColor: '#ea9700',
        }
    },
    alertSpace:{
        textAlign: 'center',
    } 

});

class InfoButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('InfoButton', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        this.state.callback(this.state.data);
    }

    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="editbutton" className={classes.fabEdit} aria-label="Manage customer" onClick={this._handleClick}>
                <ArrowForwardIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}

class CodeButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('CodeButton', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Manage button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="manage" className={classes.fabCode} aria-label="Manage customer" onClick={this._handleClick}>
                <CodeIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}

class ReactivateButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('CodeButton', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Manage button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="Reactivate" className={classes.fabWarning} aria-label="Reactivate subscription" onClick={this._handleClick}>
                <PlayCircleOutlineIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}


class SuspendButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('Suspend', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Suspend button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="suspend" className={classes.fabGo} aria-label="Pause subscription" onClick={this._handleClick}>
                <PauseCircleOutlineIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}

class InactiveButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }

        console.log('InactiveButton', this.state);
    }


    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="Inactive" className={classes.fabInactive} aria-label="Inactive">
                <WarningIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}

class DeleteButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('DeleteButton', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Manage button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="delete" className={classes.fabDelete} aria-label="Delete event" onClick={this._handleClick}>
                <DeleteForeverIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}

class EditButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: props.data,
            callback: props.callback
        }

        console.log('Suspend', this.state);
        this._handleClick = this._handleClick.bind(this);
    }

    _handleClick = () => {
        var x = Object.assign({}, this.state.customer);
        console.log('Edit button initiated',x);
        this.state.callback(this.state.data);
    }

    render() {
        var classes= this.props.classes;
        return (
            <IconButton name="edit" className={classes.fabEdit} aria-label="Edit subscription" onClick={this._handleClick}>
                <EditRoundedIcon className={classes.fabIcon}/>
            </IconButton>            
        )
    }
}



function mapDispatchToProps(dispatch) {
    return {
        setStep: spec => dispatch(setStep(spec)),
        reloadData: spec => dispatch(reloadData(spec)),
        setCloneState: spec => dispatch(setCloneState(spec))
    };
  }


  


class SubscriptionsManagerModule extends Component{

    constructor( props )
    {
        super( props );
       // console.log('TopNav', props);


        this.state = {
            plans: props.data.plans || [],
            passes: props.data.passes || [],
            focusedInput: null,
            security: {},
            loading: false,
            detail_draw_show: false,
            reload: props.refresh,
            subscription_focus: null,
            prompt_suspend: false,
            prompt_unsuspend: false,
            prompt_cancel: false,
            editor_display: false,
            show_code: false,
            edit_subscription: false,
            error: '',
        };


        this.state.security = props.security;
        this.onSubscriptionDetail = this.onSubscriptionDetail.bind(this);
        this.onShowCode = this.onShowCode.bind(this);
        this.onAddPlan = this.onAddPlan.bind(this);
        this.onDrawerClose = this.onDrawerClose.bind(this);
        this.onSubscriptionSuspend = this.onSubscriptionSuspend.bind(this);
        this.onSubscriptionUnSuspend = this.onSubscriptionUnSuspend.bind(this);
        this.onDoSuspendCancel = this.onDoSuspendCancel.bind(this);
        this.onToggleSuspendNow = this.onToggleSuspendNow.bind(this);
        this.onSubscriptionCancel = this.onSubscriptionCancel.bind(this);
        this.onCancelSubscriptionPlanNow = this.onCancelSubscriptionPlanNow.bind(this);
        this.onEditorClose = this.onEditorClose.bind(this);
        this.onSubscriptionWidgetClose = this.onSubscriptionWidgetClose.bind(this);
        this.onSubscriptionEdit = this.onSubscriptionEdit.bind(this);
        this.onEditSubscriptionClose = this.onEditSubscriptionClose.bind(this);
    }


    onEditSubscriptionClose(reload)
    {

        this.setState({'edit_subscription': false, 'subscription_focus': null});
        if(reload)
            window.location.reload();
                
    }


    onSubscriptionEdit(o)
    {

        this.setState({'edit_subscription': true, 'subscription_focus': o});
                
    }


    onShowCode(o)
    {
        this.setState({'show_code': true, 'subscription_focus': o});
    }

    onSubscriptionWidgetClose(o)
    {
        this.setState({'show_code': false, 'subscription_focus': null});
    }

    onAddPlan()
    {
        this.setState({'editor_display': true});
    }

    onEditorClose()
    {
        this.setState({'editor_display': false});
    }

    onDrawerClose()
    {
        this.setState({'detail_draw_show': false});
    }

    onSubscriptionDetail( o )
    {
        this.setState({'detail_draw_show': true, 'subscription_focus': o});
    }


    onSubscriptionSuspend(o)
    {
        this.setState({'prompt_suspend': true, 'subscription_focus': o});

    }
    onSubscriptionUnSuspend(o)
    {
        this.setState({'prompt_unsuspend': true, 'subscription_focus': o});

    }

    onSubscriptionCancel(o)
    {
        this.setState({'prompt_cancel': true, 'subscription_focus': o});

    }
   

    onDoSuspendCancel()
    {
        this.setState({'prompt_suspend': false, 'prompt_unsuspend': false, 'prompt_cancel': false, 'subscription_focus': null});
    }

    onToggleSuspendNow()
    {
        var id = this.state.subscription_focus.id ||  null;
        var chain = '';
        chain = chain +  "&id=" + id;
        var _this = this;
        fetch("/subscriptions/ajax_toggle_suspend_state", {
            method: "POST",
            mode: 'same-origin', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, *same-origin, omit                            
            body: this.state.security.name + '=' + this.state.security.token + chain,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": 'XMLHttpRequest',
                "X_REQUESTED_WITH": 'xmlhttprequest'
            }
        })
        .then(res => {
            return res.json();
        })
        .then(response => {
            //console.log(data);
            if(response.status === 'OK')
            {
                _this.setState({prompt_suspend: false, subscription_focus: null}, function()
                {
                    window.location.reload();
                });
            }
            else
            {
                _this.setState({prompt_suspend: false, prompt_unsuspend: false, error: response.error});
            }
        }).catch(function(err){
            _this.setState({prompt_suspend: false, prompt_unsuspend: false, error: 'Network error - unable to communicte with the server.'});
            console.error('Failed to delete the pass', err);
        });   
    }
  

    onCancelSubscriptionPlanNow()
    {
        var id = this.state.subscription_focus.id ||  null;
        var chain = '';
        chain = chain +  "&id=" + id;
        var _this = this;
        fetch("/subscriptions/ajax_delete_plan", {
            method: "POST",
            mode: 'same-origin', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'include', // include, *same-origin, omit                            
            body: this.state.security.name + '=' + this.state.security.token + chain,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": 'XMLHttpRequest',
                "X_REQUESTED_WITH": 'xmlhttprequest'
            }
        })
        .then(res => {
            return res.json();
        })
        .then(response => {
            //console.log(data);
            if(response.status === 'OK')
            {
                _this.setState({prompt_cancel: false, subscription_focus: null}, function()
                {
                    window.location.reload();
                });
            }
            else
            {
                _this.setState({prompt_cancel: false, prompt_unsuspend: false, error: response.error});
            }
        }).catch(function(err){
            _this.setState({prompt_cancel: false, prompt_unsuspend: false, error: 'Network error - unable to communicte with the server.'});
            console.error('Failed to delete the mandate', err);
        });   
    }
  
    render()
    {
        var classes = this.props.classes;


        return (
            <div className={classes.root}>


                <AppBar position="sticky" className="appBar">
                    <Toolbar>
                    <Typography variant="h2" className={classes.title}>
                        {window.vocab.topbar}
                    </Typography>
                    <Button  variant="outlined" className="button-green space-right" onClick={this.onAddPlan}>Add Plan</Button>
                    </Toolbar>
                </AppBar>


                <Grid container direction="row" justify="flex-start" alignContent="flex-start" alignItems="stretch" spacing={2} >

                    <Grid item xs={12} md={12} > 
                        <Grid container justify="flex-start" alignItems="stretch">
                            <Grid item xs={12} md={12}>
                                <div className="box">
                                    <Grid container justify="flex-start" alignItems="stretch">
                                        <Grid item xs={12} md={12} className={classes.alertSpace}>
                                            {this.state.error.length > 0 && (
                                                  <Alert severity="error">Opps something went wrong: {this.state.error}</Alert>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <TableContainer>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="left">
                                                                ID
                                                            </TableCell>
                                                            <TableCell align="left" className={classes.nameCell}>
                                                                Name
                                                            </TableCell> 
                                                            <TableCell align="center">
                                                                Type
                                                            </TableCell> 
                                                            <TableCell align="center">
                                                                Subscriptions
                                                            </TableCell>  
                                                            <TableCell align="center">
                                                                Status
                                                            </TableCell> 
                                                            <TableCell align="center">
                                                                Code
                                                            </TableCell>  
                                                            <TableCell align="center">
                                                                Detail
                                                            </TableCell>  
                                                            <TableCell align="center">
                                                                Edit
                                                            </TableCell>  

                                                            <TableCell align="center">
                                                                Pause
                                                            </TableCell>  
                                                            <TableCell align="center">
                                                                Cancel
                                                            </TableCell>                                                                                                                      
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {this.state.plans.length > 0 && this.state.plans.map(el => (
                                                            <TableRow key={el.id}>
                                                                <TableCell align="left">
                                                                    {el.id}
                                                                </TableCell>
                                                                <TableCell align="left" className={classes.nameCell}>
                                                                    {el.name}
                                                                </TableCell> 
                                                                <TableCell align="center">
                                                                    {el.type}
                                                                </TableCell> 
                                                                <TableCell align="center">
                                                                    {el.active_subscriptions}
                                                                </TableCell>   
                                                                <TableCell align="center">
                                                                    {el.status}
                                                                </TableCell>  
                                                                <TableCell align="center">
                                                                    <CodeButton classes={classes} callback={this.onShowCode} data={el}/>
                                                                </TableCell>                                                                                                                                                                                                
                                                                <TableCell align="center">
                                                                    <InfoButton classes={classes} callback={this.onSubscriptionDetail} data={el}/>
                                                                </TableCell> 

                                                                <TableCell align="center">
                                                                    {el.status === 'Active' && (
                                                                        <EditButton classes={classes}  data={el}  callback={this.onSubscriptionEdit}/>
                                                                    )}
                                                                    {el.status === 'Paused' && (
                                                                        <InactiveButton classes={classes} />
                                                                        )}
                                                                    {el.status !== 'Paused' && el.status !== 'Active' && (
                                                                        <InactiveButton classes={classes} />
                                                                    )}                                                                      
                                                                                                                                       
                                                                </TableCell>  

                                                                <TableCell align="center">
                                                                    {el.status === 'Active' && (
                                                                        <SuspendButton classes={classes}  data={el}  callback={this.onSubscriptionSuspend}/>
                                                                    )}
                                                                    {el.status === 'Paused' && (
                                                                        <ReactivateButton classes={classes}  data={el}  callback={this.onSubscriptionUnSuspend}/>
                                                                    )}
                                                                    {el.status !== 'Paused' && el.status !== 'Active' && (
                                                                        <InactiveButton classes={classes} />
                                                                    )}                                                                      
                                                                                                                                       
                                                                </TableCell>  
                                                                <TableCell align="center">
                                                                    <DeleteButton classes={classes}  data={el} callback={this.onSubscriptionCancel}/>
                                                                </TableCell> 
                                                            </TableRow>
                                                        ))}
                                                        {this.state.plans.length === 0 && (
                                                            <TableRow>
                                                                <TableCell align="center" colSpan={10}>
                                                                    No subscription plans
                                                                </TableCell>
                                                            </TableRow>
                                                        )}                                                        

                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>                                    

                </Grid>
                {this.state.detail_draw_show === true && (
                    <SubscriptionDetailDrawer where={{'top': false, 'bottom': false, 'left': false, 'right': true}} subscription={this.state.subscription_focus} onClose={this.onDrawerClose}/>
                )}
                {this.state.prompt_suspend === true && (
                    <CoreDialog title="Pause subscription plan" body="Are you sure that you want to pause this subscription plan?<br/><br/><b>Important:</b> By suspending this subscription, no future mandates can be signed for this subscription plan. However, any exisiting associated mandates will remain active and continue to be processed." state={true} danger={true} onCancel={this.onDoSuspendCancel} actions={[{label:"Pause this subscription", action:this.onToggleSuspendNow}]}  />
                )}  
                {this.state.prompt_unsuspend === true && (
                    <CoreDialog title="Resume subscription plan" body="Are you sure that you want to resume this subscription?<br/><br/><b>Important:</b> Once resumed, customers will be able to subscribe to this plan." state={true} danger={true} onCancel={this.onDoSuspendCancel} actions={[{label:"Resume this subscription", action:this.onToggleSuspendNow}]}  />
                )}  
                {this.state.prompt_cancel === true && (
                    <CoreDialog title="Cancel Subscription" 
                    body="<b><i>Warning this cannot be undone! Please consider using Pause instead</i><br/><br/></b>Are you sure that you wish to continue? If you cancel this subscription plan, any associated mandates will be stopped and associated customers notified." state={true} danger={true} onCancel={this.onDoSuspendCancel} actions={[{label:"Cancel subscription plan, now", action:this.onCancelSubscriptionPlanNow}]}  />
                )}  
                {this.state.editor_display === true && (
                    <SubscriptionAddPlan open={true} security={this.state.security} passes={this.state.passes} closeCustomerPanel={this.onEditorClose}/>
                )}
                {this.state.show_code && (<CodeDialog callback={this.onSubscriptionWidgetClose} data={this.state.subscription_focus} 
                                                    options={[{name:'Subscription subscribe link', type:'address'}, 
                                                                    {name: 'Orange button widget', type:'obutton'}, 
                                                                    {name: 'Green button widget', type:'gbutton'},
                                                                    {name: 'Blue button widget', type:'bbutton'},
                                                                    {name: 'White button widget', type:'wbutton'},
                                                              ]}  /> )}

                {
                    this.state.edit_subscription && (
                        <SubscriptionEditDialog subscription={this.state.subscription_focus} security={this.state.security} state={true} onCancel={this.onEditSubscriptionClose}/>
                    )
                }
                
            </div>            
        );
    }

};



const SubscriptionsManager = connect(null, mapDispatchToProps)(SubscriptionsManagerModule);
export default withStyles(styles)(SubscriptionsManager);
